const { createEditor, Node } = require('slate');

const parseFilesFromContent = (content) => {
  const { context, value } = content;
  const editor = createEditor();
  value.forEach(editor.insertNode);

  const nodes = Array.from(Node.descendants(editor)).filter(
    ([node]) => node.type === 'fileBlock'
  );

  const keys = Array.from(new Set(nodes.map((n) => n[0].entity)).values());

  return keys
    .map((key) => context.entities[key])
    .filter((entity) => !!entity)
    .map((entity) => ({
      fileUrl: entity.data.fileUrl,
      name: entity.data.name,
      size: entity.file.size,
    }));
};

module.exports = parseFilesFromContent;
